import { Flex, Text, Select } from '@scale/scaleui-radix';
import type { HubstaffUserIdentityType } from '@scale/genai-compass-shared/cards/hubstaff_member_actions';

interface UserIdentityTypeSelectorProps {
  identityType: HubstaffUserIdentityType;
  onChange: (identityType: HubstaffUserIdentityType) => void;
}

export default function UserIdentityTypeSelector({
  identityType,
  onChange,
}: UserIdentityTypeSelectorProps) {
  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="bold">
        Step 3: Select user identity type <span style={{ color: 'red' }}>*</span>
      </Text>
      <Select.Root
        value={identityType}
        onValueChange={value => onChange(value as HubstaffUserIdentityType)}
      >
        <Select.Trigger placeholder="Select identity type" />
        <Select.Content>
          <Select.Item value="Corp Id">Corp Id</Select.Item>
          <Select.Item value="Corp Email">Corp Email</Select.Item>
          <Select.Item value="Hubstaff Id">Hubstaff Id</Select.Item>
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
